import { useCallback } from 'react';
import { useSettings } from '@/state/settingsStore';
import { translate, type TKey, type TParams } from './index';
import type { Lang } from '@/domain/content.types';

export interface Translator {
  (key: TKey, params?: TParams): string;
}

/** `t()` bound to the active language, plus the language itself. */
export function useT(): { t: Translator; lang: Lang } {
  const lang = useSettings((s) => s.lang);
  const t = useCallback<Translator>((key, params) => translate(lang, key, params), [lang]);
  return { t, lang };
}
